import { alpha, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import {
  Box,
  ButtonBase,
  Chip,
  IconButton,
  Stack,
  Tooltip,
  Typography
} from '@mui/material';
import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';

import Search from './Search';
import Profile from './Profile';
import MobileSection from './MobileSection';
import Logo from '@components/logo';
import { useThemeMode } from '../../../../themes/ThemeModeContext';

function ThemeToggleButton({ compact = false }) {
  const theme = useTheme();
  const { mode, toggleColorMode } = useThemeMode();
  const isDark = mode === 'dark';

  if (compact) {
    return (
      <Tooltip title={isDark ? 'Chuyển sang light mode' : 'Chuyển sang dark mode'}>
        <IconButton
          onClick={toggleColorMode}
          sx={{
            border: '1px solid',
            borderColor: 'divider',
            backgroundColor: alpha(theme.palette.background.paper, 0.72)
          }}
        >
          {isDark ? <LightModeRoundedIcon /> : <DarkModeRoundedIcon />}
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <ButtonBase
      onClick={toggleColorMode}
      sx={{
        px: 1.5,
        py: 1,
        borderRadius: 999,
        border: '1px solid',
        borderColor: 'divider',
        backgroundColor: alpha(theme.palette.background.paper, theme.palette.mode === 'dark' ? 0.9 : 0.72)
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: '50%',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: isDark ? alpha(theme.palette.warning.main, 0.16) : alpha(theme.palette.primary.main, 0.14),
            color: isDark ? 'warning.main' : 'primary.main'
          }}
        >
          {isDark ? <LightModeRoundedIcon fontSize="small" /> : <DarkModeRoundedIcon fontSize="small" />}
        </Box>
        <Box sx={{ textAlign: 'left' }}>
          <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary', lineHeight: 1.1 }}>
            Giao diện
          </Typography>
          <Typography variant="subtitle2">{isDark ? 'Dark mode' : 'Light mode'}</Typography>
        </Box>
      </Stack>
    </ButtonBase>
  );
}

export default function HeaderContent() {
  const theme = useTheme();
  const downLG = useMediaQuery((muiTheme) => muiTheme.breakpoints.down('lg'));

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2} sx={{ width: '100%' }}>
      <Stack direction="row" alignItems="center" spacing={2} sx={{ minWidth: 0 }}>
        <Logo />
        {!downLG && (
          <Box>
            <Typography variant="h5" sx={{ lineHeight: 1.1 }}>
              IELTS Gurus Workspace
            </Typography>
            <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 0.5 }}>
              <AccessTimeRoundedIcon sx={{ fontSize: 15, color: 'text.secondary' }} />
              <Typography variant="body2" color="text.secondary">
                Học tập tập trung, theo sát hạn nộp và tiến độ của bạn.
              </Typography>
            </Stack>
          </Box>
        )}
      </Stack>

      {!downLG && (
        <Stack direction="row" spacing={1.25} alignItems="center" sx={{ flexShrink: 0 }}>
          <Search />
          <Chip
            label="Trang chủ"
            size="small"
            sx={{
              borderRadius: 999,
              backgroundColor: alpha(theme.palette.primary.main, 0.1),
              color: 'primary.main',
              fontWeight: 700
            }}
          />
          <ThemeToggleButton />
          <Profile />
        </Stack>
      )}

      {downLG && (
        <Stack direction="row" spacing={1} alignItems="center">
          <ThemeToggleButton compact />
          <MobileSection />
        </Stack>
      )}
    </Stack>
  );
}
